import React from 'react';
import './App.scss';
import './assets/styles/main.scss';

import { Provider } from 'react-redux';
import { RibbonProvider, ModalProvider, FeaturesProvider } from '@dataswift/shared';
import { BrowserRouter as Router } from 'react-router-dom';
import { VERSION, FEATURES } from './app-config';
import { store } from './redux/store';
import Routes from './components/Routes';
import ThemeProvider from './styles/Provider';

const App: React.FC = () => {
  console.log('Dev portal version:', VERSION);

  return (
    <Provider store={store}>
      <Router>
        <ThemeProvider>
          <ModalProvider>
            <RibbonProvider>
              <FeaturesProvider value={FEATURES}>
                <Routes />
              </FeaturesProvider>
            </RibbonProvider>
          </ModalProvider>
        </ThemeProvider>
      </Router>
    </Provider>
  );
};

export default App;
